import axios from 'axios';
import { GET_SITECORE_COMPONENTS } from './constants';
import { SitecoreComponentsResponse } from '../type';

export const getSitecoreComponentData = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get<number, SitecoreComponentsResponse>(GET_SITECORE_COMPONENTS())
        .then((res) => {
          const { data } = res;
          resolve(data);
        })
        .catch(() => {
          reject('Error in getSitecoreComponentData axios!');
        });
    } catch (error) {
      console.error(
        'in sitecoreService > getSitecoreComponentData, Err===',
        error
      );
      reject('System error. Please try again later.');
    }
  });
};
